import React, {useEffect} from 'react'
import './Stalert.css'
import Androidscreenshoot from '../images/Stalertimages/Androidscreenshoot.png'

import Artboard2 from '../images/Stalertimages/Artboard2.png'
import Artboard3 from '../images/Stalertimages/Artboard3.png'
import Artboard4 from '../images/Stalertimages/Artboard4.png'
import Artboard5 from '../images/Stalertimages/Artboard5.png'
import Artboard6 from '../images/Stalertimages/Artboard6.png'
import Artboard7 from '../images/Stalertimages/Artboard7.png'
import Artboard8 from '../images/Stalertimages/Artboard8.png'
import Artboard9 from '../images/Stalertimages/Artboard9.png'
import Artboard10 from '../images/Stalertimages/Artboard10.png'
import Artboard11 from '../images/Stalertimages/Artboard11.png'
import Artboard12 from '../images/Stalertimages/Artboard12.png'
import Artboard13 from '../images/Stalertimages/Artboard13.png'
import Artboard14 from '../images/Stalertimages/Artboard14.png'
import Artboard14s from '../images/Stalertimages/Artboard14s.gif'
import Artboard15 from '../images/Stalertimages/Artboard15.png'
import Artboard16 from '../images/Stalertimages/Artboard16.png'
import Artboard17 from '../images/Stalertimages/Artboard17.png'
import Artboard18 from '../images/Stalertimages/Artboard18.png'
import Artboard19 from '../images/Stalertimages/Artboard19.png'
import Footer from '../Component/footer'

function Stalert() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        
         
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard11} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard12} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard13} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard14} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboards"><img src={Artboard14s} height="auto" width="auto" alt="" text-align="center" /></div>
         <div className="imagevh" id="artboard"><img src={Artboard15} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard16} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard17} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard18} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard19} height="auto" width="100%" alt=""/></div>
          

          <div className="imagevh" id="artboard" ><Footer /></div> 


         
        </div>
    )
}

export default Stalert